module.exports = __webpack_public_path__ + "static/locked.30b76538.png";